import "./MainWrapper.scss";

export default {
  root: "im-main-wrapper",
  withBackground: "im-main-wrapper--with-background",
  customBackground: "im-main-wrapper__custom-background",
};
